import type { SitePreviewData } from '@libs/common-next';

import css from './switch.module.scss';

type Props = {
    name: keyof SitePreviewData;
    value?: string | boolean;
    onChange: (key: keyof SitePreviewData, value: boolean) => void;
};

export function Switch({ name, value, onChange }: Props) {
    return (
        <label className={css.toggle}>
            <input
                id={name}
                checked={Boolean(value)}
                className={css.input}
                onChange={e => onChange(name, e.target.checked)}
                type="checkbox"
            />
            <span className={css.slider} />
        </label>
    );
}
